/**
 * Avatar circular da Minas Brasil — o logo (mapa do Brasil com Minas Gerais
 * em destaque) centralizado num círculo branco com anel sutil. Reaproveitado
 * no header, na sidebar e na tela de acesso.
 */
export function Avatar({
  size = 40,
  ring = true,
  className = '',
}: {
  size?: number;
  ring?: boolean;
  className?: string;
}) {
  const inner = Math.round(size * 0.64);
  return (
    <div
      className={`rounded-full bg-white flex items-center justify-center overflow-hidden flex-shrink-0 ${
        ring ? 'ring-1 ring-black/5' : ''
      } ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src="/assets/logo-mb.svg"
        alt="Minas Brasil"
        width={inner}
        height={inner}
        className="object-contain"
        draggable={false}
      />
    </div>
  );
}
